<template>
  <a-modal
    title="提交资料"
    :width="600"
    :maskClosable="false"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="visible = false"
  >
    <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="资料名称" v-if="submitConfig.name>0">
        <a-input :disabled="!eventOpen" v-decorator="['workName', validatorRules.workName]"></a-input>
      </a-form-item>
      <a-form-item label="简介" v-if="submitConfig.desc>0">
        <a-textarea
        :disabled="!eventOpen"
          v-decorator="['workDesc', validatorRules.workDesc]"
        ></a-textarea>
      </a-form-item>
      <a-form-item label="承诺书" v-if="submitConfig.agreeFile>0">
        <j-upload
          v-decorator="['agreeFile', validatorRules.agreeFile]"
          :uploadTarget="'qiniu'"
          :disabled="!eventOpen"
          :fileType="'image'"
          :number="1"
          :minFileSize="100"
          :maxFileSize="1"
          :trigger-change="true"
        ></j-upload>
        <div v-if="eventInfo.agreeTemplate">
            <p>
            下载承诺书范本，打印后签名保存为jpg格式在此上传，图片限制2MB以内。
          </p>
          <a :href="eventInfo.agreeTemplate_url" target="_blank"
            ><a-icon type="cloud-download" /> 承诺书范本下载</a
          >
        </div>
      </a-form-item>
      <a-form-item label="程序文件" v-if="submitConfig.codeFile>0">
        <j-upload
          v-decorator="['workFile', validatorRules.workFile]"
          :uploadTarget="'qiniu'"
          :number="1"
          :disabled="!eventOpen"
          text="点击上传文件"
          :maxFileSize="eventInfo.workSize ? eventInfo.workSize : 100"
          :trigger-change="true"
        ></j-upload>
      </a-form-item>
      <a-form-item label="视频文件" v-if="submitConfig.videoFile>0">
        <j-upload
          v-decorator="['videoFile', validatorRules.videoFile]"
          :uploadTarget="'qiniu'"
          :disabled="!eventOpen"
          :number="1"
          text="点击上传视频"
          :maxFileSize="eventInfo.workSize ? eventInfo.workSize : 100"
          :trigger-change="true"
        ></j-upload>
      </a-form-item>
      <a-form-item label="作品资料包(限ZIP文件)" v-if="submitConfig.zipFile>0">
        <j-upload
          v-decorator="['zipFile', validatorRules.zipFile]"
          :uploadTarget="'qiniu'"
          :disabled="!eventOpen"
          accept=".zip"
          :number="2"
          text="点击上传附件"
          :maxFileSize="eventInfo.workSize ? eventInfo.workSize : 100"
          :trigger-change="true"
        ></j-upload>
      </a-form-item>
      <a-form-item label="自荐表(限excel文件)" v-if="submitConfig.biographicalNotes>0">
        <j-upload
          v-decorator="['biographicalNotes', validatorRules.biographicalNotes]"
          :uploadTarget="'qiniu'"
          :disabled="!eventOpen"
          accept=".xlsx,.xls"
          :number="1"
          text="点击上传附件"
          :maxFileSize="eventInfo.workSize ? eventInfo.workSize : 100"
          :trigger-change="true"
        ></j-upload>
        <div v-if="eventInfo.agreeTemplate">
          <a :href="eventInfo.agreeTemplate_url" target="_blank"
            ><a-icon type="cloud-download" /> 自荐表模板下载</a
          >
        </div>
      </a-form-item>
      <a-form-item label="证书及获奖经历(限PDF文件)" v-if="submitConfig.awardExperience>0">
        <j-upload
          v-decorator="['awardExperience', validatorRules.awardExperience]"
          :uploadTarget="'qiniu'"
          :disabled="!eventOpen"
          accept=".pdf"
          :number="1"
          text="点击上传附件"
          :maxFileSize="eventInfo.workSize ? eventInfo.workSize : 100"
          :trigger-change="true"
        ></j-upload>
      </a-form-item>
      <a-form-item label="学习报告(限PDF文件)" v-if="submitConfig.studyReport>0">
        <j-upload
          v-decorator="['studyReport', validatorRules.studyReport]"
          :uploadTarget="'qiniu'"
          :disabled="!eventOpen"
          accept=".pdf"
          :number="1"
          text="点击上传附件"
          :maxFileSize="eventInfo.workSize ? eventInfo.workSize : 100"
          :trigger-change="true"
        ></j-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { httpAction, getAction, postAction } from "@/api/manage";
import JUpload from "@/components/jeecg/JUpload";
import pick from "lodash.pick";
export default {
  name: "SubmitWorkModal",
  components: {
    JUpload,
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      model: {},
      myEvent: {},
      eventInfo: {},
      eventOpen: true,
      submitConfig: {
          name: 2, //作品名称
          desc: 1, //描述
          agreeFile:1 ,//承诺书
          codeFile: 1, //程序文件
          videoFile: 1, //视频文件
          zipFile: 1, //附件文件
          biographicalNotes: 1, //个人简历
          studyReport: 1, //学习报告
          awardExperience: 1 //证书及获奖经历
      },
      validatorRules: {
        workName: {
          rules: [{ required: true, message: "请输入名称!" }],
        },
        workDesc: {
          rules: [{ required: true, message: "请输入描述!" }],
        },
        agreeFile: {
          rules: [
            { required: true, message: "请上传承诺书! 100KB-1MB的JPG图片" },
          ],
        },
        workFile: {
          rules: [{ required: true, message: "请上传文件!" }],
        },
        zipFile: {
          rules: [{ required: true, message: "请上传文件!" }],
        },
        videoFile: {
          rules: [{ required: true, message: "请上传视频!" }],
        },
        biographicalNotes: {
          rules: [{ required: true, message: "请上传文件!" }],
        },
        studyReport: {
          rules: [{ required: true, message: "请上传文件!" }],
        },
        awardExperience: {
          rules: [{ required: true, message: "请上传文件!" }],
        },
      },
    };
  },
  created() {},
  methods: {
    open(myEvent) {
      this.visible = true;
      this.form.resetFields()
      this.myEvent = myEvent
      this.getEventInfo(myEvent.eventId).then(()=>{
        //已提交作品回显
        if (myEvent.worksVOS && myEvent.worksVOS.length > 0) {
          let workInfo = myEvent.worksVOS[0];
          console.log(workInfo);
          this.$nextTick(() => {
            this.form.setFieldsValue(
              pick(workInfo, "workName", "workDesc", "workFile", "agreeFile", "zipFile", "videoFile","biographicalNotes","studyReport","awardExperience")
            );
          });
        }
      })
      
    },
    getEventInfo(eventId) {
      this.confirmLoading = true;
      return getAction('/teaching/teachingEvent/queryById', { id: eventId }).then((res) => {
        if (res.success) {
          this.eventInfo = res.result
          if(this.eventInfo.submitConfig){
            this.submitConfig = JSON.parse(this.eventInfo.submitConfig)
          }
          // console.log("current", res.timestamp);
          // console.log("begin remain", this.eventInfo.eventBegin, new Date(this.eventInfo.eventBegin).getTime(), new Date(this.eventInfo.eventBegin).getTime() - res.timestamp );
          // console.log("end reamain", this.eventInfo.eventEnd, new Date(this.eventInfo.eventEnd).getTime(), res.timestamp - new Date(this.eventInfo.eventEnd).getTime() );
          if(this.eventInfo.eventBegin && this.eventInfo.eventEnd 
            && new Date(this.eventInfo.eventBegin).getTime() < res.timestamp 
            && new Date(this.eventInfo.eventEnd).getTime() > res.timestamp
            ){
              
              this.eventOpen = true
          }else{
            // this.eventOpen = false
          }
          console.log(this.eventOpen);
          this.validatorRules.workName.rules[0].required = this.submitConfig.name==2
          this.validatorRules.workDesc.rules[0].required = this.submitConfig.desc==2
          this.validatorRules.agreeFile.rules[0].required = this.submitConfig.agreeFile==2
          this.validatorRules.workFile.rules[0].required = this.submitConfig.codeFile==2
          this.validatorRules.videoFile.rules[0].required = this.submitConfig.videoFile==2
          this.validatorRules.zipFile.rules[0].required = this.submitConfig.zipFile==2
          this.validatorRules.biographicalNotes.rules[0].required = this.submitConfig.biographicalNotes==2
          this.validatorRules.studyReport.rules[0].required = this.submitConfig.studyReport==2
          this.validatorRules.awardExperience.rules[0].required = this.submitConfig.awardExperience==2
          this.confirmLoading = false
        } else {
          this.$message.warning("活动不存在");
        }
      })
    },
    handleOk() {
      let that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          values.eventId = that.myEvent.eventId;
          values.eventCategory = that.myEvent.myEventCategory;
          if (that.myEvent.worksVOS && that.myEvent.worksVOS.length > 0) {
            values.id = that.myEvent.worksVOS[0].workId;
          }
          postAction("/teaching/teachingWork/submitWork", values)
            .then((res) => {
              if (res.success) {
                that.visible = false;
                that.$success({
                  title: "提交成功",
                  content: (
                    <div>
                      <p>如需修改，可在活动结束前再次提交。</p>
                    </div>
                  ),
                });
                that.$emit("ok");
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style>
</style>